import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SignupPage from './pages/SignupPage'; // Import the new page
import RequestDemoPage from './pages/RequestDemoPage';
import PricesPage from './pages/PricesPage';
import InsightsPage from './pages/InsightsPage'; 
import DataStatsPage from './pages/DataStatsPage';
import ReportsPage from './pages/ReportsPage';
import TendersPage from './pages/TendersPage';
import ConsultingPage from './pages/ConsultingPage';
import EventsPage from './pages/EventsPage';
import ForecastingPage from './pages/ForecastingPage';
import AdvantagesPage from './pages/AdvantagesPage';
import MarketsPage from './pages/MarketsPage';
import MediaCenterPage from './pages/MediaCenterPage';
import GrainsPage from './pages/GrainsPage';
import DeliveryPage from './pages/DeliveryPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/signup" element={<SignupPage />} /> {/* Add the new route */}
          <Route path="/request-demo" element={<RequestDemoPage />}/>
          <Route path="/prices" element={<PricesPage />} />  
          <Route path="/insights" element={<InsightsPage />} /> 
          <Route path="/data-statistics" element={<DataStatsPage />} />
          <Route path="/reports" element={<ReportsPage />} /> 
          <Route path="/tenders" element={<TendersPage />} />
          <Route path="/consulting" element={<ConsultingPage />} /> 
          <Route path="/forecasting" element={<ForecastingPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/advantages" element={<AdvantagesPage />} /> 
          <Route path="/markets" element={<MarketsPage />} />
          <Route path="/media-center" element={<MediaCenterPage />} />
          <Route path="/markets/grains" element={<GrainsPage />} />
          <Route path="/delivery-mode" element={<DeliveryPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;